import React from 'react';
import PropTypes from 'prop-types';

const HeaderProfileTitle = ({ children = null }) => (
  <div className="vf-header-profile__title">
    <div className="vf-header-profile__title__icon">
      <i className="versa-user" />
    </div>
    <div className="vf-header-profile__title__text">
      {children}
    </div>
  </div>
);

HeaderProfileTitle.displayName = 'HeaderProfile Title';

HeaderProfileTitle.propTypes = {
  children: PropTypes.string,
};

export default HeaderProfileTitle;
